import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { ToastContainerComponent } from './shared/toast/toast-container/toast-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NgOptimizedImage, RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html',
  // Default, never OnPush: every routed page renders inside this view, and most of them set plain
  // fields from HTTP callbacks. Under OnPush those never reached the screen until a click did.
})
export class AppComponent {
  title = 'declunk-mvp-front';

  // Until the first navigation settles the outlet is empty: the guards are still waiting on
  // `/users/me/` (and the project, for a `?projectId` deep link) and the lazy chunk may still be
  // loading. Later navigations keep the current page on screen, so only the first one needs this.
  protected readonly initialNavigationPending = toSignal(
    inject(Router).events.pipe(
      filter(
        (event) =>
          event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError,
      ),
      take(1),
      map(() => false),
    ),
    { initialValue: true },
  );
}
